import { defaultTo } from 'lodash-es';

type ObjektMitAufgaben = {
  aufgaben?: {status: string}[] | null;
  aufgabenStatistik?: {status: string; anzahl: number}[] | null;
};


const countAllOffeneAufgaben = (objekte: ObjektMitAufgaben[]): number => {
  return countAllAufgabenByStatus(objekte, 'Offen');
};

const countAllAufgabenByStatus = (objekte: ObjektMitAufgaben[], status: string): number => {
  return objekte.reduce(
    (total, objekt) => (total + countAufgabenByStatus(objekt, status)),
    0,
  );
};

export const countAllOffenOrAbgeschlosseneAufgaben = (objekt: ObjektMitAufgaben): number => {
  return countAllOffeneAufgaben([objekt]) + countAbgeschlosseneAufgaben(objekt);
};

export const countOffeneAufgaben = (objekt: ObjektMitAufgaben): number => {
  return countAufgabenByStatus(objekt, 'Offen');
};

export const countAbgeschlosseneAufgaben = (objekt: ObjektMitAufgaben): number => {
  return countAufgabenByStatus(objekt, 'Abgeschlossen');
};

const countAufgabenByStatus = (objekt: ObjektMitAufgaben, status: string): number => {
  const statistic = objekt.aufgabenStatistik?.find(stat => stat?.status === status);
  if (!statistic) {
    return defaultTo(objekt.aufgaben?.filter(aufgabe => aufgabe?.status === status).length, 0);
  }
  return defaultTo(statistic?.anzahl, 0);
};
